export const CONSENT_KEY = "redglass_consent_v2";

export function payloadFor(choice) {
  if (choice === "accept_all") {
    return {
      ad_storage: 'granted',
      analytics_storage: 'granted',
      ad_user_data: 'granted',
      ad_personalization: 'granted',
    };
  }
  if (choice === "reject_all") {
    return {
      ad_storage: 'denied',
      analytics_storage: 'denied',
      ad_user_data: 'denied',
      ad_personalization: 'denied',
    };
  }
  const a = !!choice.analytics;
  const ads = !!choice.ads;
  return {
    analytics_storage: a ? 'granted' : 'denied',
    ad_storage: ads ? 'granted' : 'denied',
    ad_user_data: ads ? 'granted' : 'denied',
    ad_personalization: ads ? 'granted' : 'denied',
  };
}

export function saveConsent(choice) {
  localStorage.setItem(CONSENT_KEY, JSON.stringify(choice));
}

export function readConsent() {
  try { return JSON.parse(localStorage.getItem(CONSENT_KEY)); }
  catch { return null; }
}

export function updateConsent(choice) {
  const payload = payloadFor(choice);
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag('consent', 'update', payload);
    window.dataLayer && window.dataLayer.push({ event: 'consent_update', consent_state: payload });
  }
}
